export const storeCategoryMap = {
  18: "식품",
  19: "패션잡화",
  20: "음료·건강",
  21: "생활·세제",
  22: "문구·문화",
  23: "반려동물",
  24: "인테리어",
  25: "의류",
  26: "미용·클렌징",
  27: "식물·꽃",
};
